import { ECountry } from '@portals/help-center-core';
import { TPagination } from '@/_types';

export const DISABLED_PAGINATION: TPagination = {
  offset: 0,
  limit: 1000,
};

export const DEBOUNCE_DELAY = 200;
export const THROTTLE_DELAY = 300;

export const SEARCH_AVAILABLE_COUNTRIES: Array<ECountry> = [
  ECountry.RUSSIA,
  ECountry.CHINA,
  ECountry.ARMENIA,
  ECountry.BELARUS,
  ECountry.KYRGYZSTAN,
  ECountry.KAZAKHSTAN,
  ECountry.UZBEKISTAN,
  ECountry.TAJIKISTAN,
  ECountry.GEORGIA,
];

export const HC_FORCE_CRASH = 'HC_FORCE_CRASH';
